(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@cainiaofe/cn-ui"), require("lodash-es"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@cainiaofe/cn-ui", "lodash-es", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["CN_UI_LOWCODE"] = factory(require("react"), require("@cainiaofe/cn-ui"), require("lodash-es"), require("react-dom"));
	else
		root["CN_UI_LOWCODE"] = factory(root["React"], root["CNUI"], root["_"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__88__) {
return 